export default __webpack_public_path__ + "static/media/82.51044087.jpeg";